import {
  PrefixIcon as PrefixIconEnum,
  PrefixIconColor,
  PrefixIconSize,
  TextAppearanceKeys,
  TextEmphasisKeys,
  TextSizeKeys,
} from '@/constants/enum';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import PrefixIcon from '@/pages/Checkout/components/PrefixIcon';
import TextStyle from '@/pages/Checkout/components/TextStyle';
import checkoutRuleSlice, { checkoutRuleSettingsSelector } from '@/redux/slice/checkoutRule.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const Step3 = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const state = useSelector(checkoutRuleSettingsSelector);
  const handleUpdateState =
    (key: keyof IStateCheckoutRule) =>
    (value: TextSizeKeys | TextAppearanceKeys | TextEmphasisKeys | PrefixIconColor | PrefixIconSize | PrefixIconEnum) => {
      dispatch(checkoutRuleSlice.actions.handleChange({ key, value }));
    };
  return (
    <div>
      <div className="mt-12">
        <TextStyle
          textSize={state.textSize}
          textAppearance={state.textAppearance}
          textEmphasis={state.textEmphasis}
          changeTextSize={handleUpdateState('textSize')}
          changeTextAppearance={handleUpdateState('textAppearance')}
          changeTextEmphasis={handleUpdateState('textEmphasis')}
          defaultOpen={!!id}
        />
      </div>

      <div className="mt-12">
        <PrefixIcon
          iconId={state.iconId}
          iconSize={state.iconSize}
          iconColor={state.iconColor}
          changeIcon={handleUpdateState('iconId')}
          changeIconSize={handleUpdateState('iconSize')}
          changeIconColor={handleUpdateState('iconColor')}
          defaultOpen={!!id}
        />
      </div>
    </div>
  );
};

export default Step3;
